const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');
const { Pagination } = require('../../components/pagination');
const { previewHostname } = require('../../../../shared/preview-slug');

function domainStatus(site) {
  if (site.domainStatus === 'active') return 'Proxy active';
  return 'Waiting for first proxy request';
}

const SitesPage = component(() => {
  return {
    view: ({ attrs: {
      sites,
      onNewSite,
      page,
      hasPrevious,
      hasNext,
      loading,
      onPageChange
    } }) => m('section.panel',
      m(Breadcrumbs, { items: [{ label: 'Sites' }] }),
      m('h2', 'Your sites'),
      m('a.button', { href: '/sites/new', onclick: onNewSite }, 'Add site'),
      loading && !sites.length && m('p.muted', 'Loading sites…'),
      !loading && !sites.length && m('p.muted', 'No sites yet.'),
      m('div.sites-list', sites.map(site => m('article.site',
        m('h3', m('a', { href: `/sites/${site.id}` }, site.name)),
        m('p', site.domains.join(', ')),
        m('p', m('a', {
          href: `https://${previewHostname(site)}`,
          target: '_blank',
          rel: 'noreferrer'
        }, previewHostname(site))),
        m('p.site-status', domainStatus(site)),
        m('code', site.origin)
      ))),
      (hasPrevious || hasNext) && m(Pagination, {
        page,
        hasPrevious,
        hasNext,
        loading,
        itemCount: sites.length,
        label: 'sites',
        onChange: onPageChange
      })
    )
  };
});

module.exports = { SitesPage };
